import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
// import "../../css/bootstrap.min.css";
import "../../../css/font.css";
import axios from "axios";
import moment from "moment"; 
import { eligibility,mailsend,schoolsurl } from "../../../apis/urls";
import { decode } from "html-entities";

const AthletView = () => {

    useEffect( ()=>{
        AthletListing();
    },[])

    const { id } = useParams();
    const username = localStorage.getItem('username')

    let navigate = useNavigate();

    const { sid,aid } = useParams();

    const [result,setResult] = useState('');
    const [schName,setSchName] = useState([]);
    const AthletListing = () => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: eligibility+sid+'/'+aid,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            setResult(response.data.data);
			console.log('showsss',response.data.data)
           
          }).catch((error) =>{ 
            
            console.log('error',error.message)

			//localStorage.removeItem('token')
        	//navigate("/")
            

          });

    }




    const DeleteAthleticElig = (aid) => {

        let r = window.confirm("Are you sure you want to delete this Athletic Eligibility?");

        if(r == true){
            
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: eligibility+id+'/'+aid,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                navigate("/school_list/athlet_list/"+sid)

                // MAIL SENDING

			let token = "Bearer "+localStorage.getItem('token');
			//console.log(token)
			const data = {
				name: 'Robin Ayler',
				current_login:username,
				studentName:result.first_name+' '+result.last_name,
                grade:result.current_grade,
                schoolName: result.school.name,
				new:'',
				action:'Deleted',
			}

           
			
			const instance = axios.create({

				baseURL: mailsend+'/studentMail',

				timeout: 1000000,

				headers: {'authorization': token}

			});
			
			instance.post('',data).then((response) =>{
				console.log("mail send successfully")

			}).catch((error) =>{
				
			console.log('error in sending',error)

			});



			// END MAIL SENDING


            }).catch((error) =>{
                
                console.log('error',error.message)
            });
        }
    }


    return(
        <div>
            <aside class="right-side areas">
                <div class="content-area dash-contentss">

                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <i class="icon-library1"></i>
                            <h2 class="page-title">Athletic Eligibility</h2>
                        </div>

                        <div class="page-rightside-action-column"></div>
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to={"/school_list/athlet_list/"+sid}> Athletic Eligibility</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Eligibility View</li>
                        </ol>
                    </nav>

                    <div className="tab-content">

                        <div id="generalinfo" class="container tab-pane active"><br/>
                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>First Name</label>
                                    <div>{result.first_name}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Last Name</label>
                                    <div>{result.last_name}<br/>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>Date of Birth</label>
                                    <div>{result.dob}<br/>
                                    </div>
                                </div>
                            
                                
                            </div>

                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>Gender </label>
                                    <div>{result.gender}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Grade</label>
                                    <div>{result.current_grade}<br/>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>Entered 8th</label>
                                    <div>{result.year_8}<br/>
                                    </div>
                                </div>
                                
                            </div>

                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>Entered 9th </label>
                                    <div>{result.year_9}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>School Last Attended</label>
                                    {result.status1 === 'HOME SCHOOL'?
                                    <div>
                                      HOME SCHOOL - NOW FULLY ENROLLED<br/>  
                                    </div>:
                                    <div>{result.status1}<br/>
                                    </div>
                                    }
                                </div>


                                {result.status1 === "GISA/GIAA MEMBER SCHOOL"?
                                <div class="col-md-4">
                                    <label>LAST SCHOOL NAME</label>
                                    <div>{decode(result.last_school)}</div>
                                </div>:null   
                                }

                                
                                {result.status1 === "HOME SCHOOL"?
                                <div class="col-md-4">
                                    <label>LAST SCHOOL NAME</label>
                                    <div>{decode(result.home_school)}</div>
                                </div>:null   
                                }

                                {result.status1 === "PUBLIC SCHOOL"?
                                    <div class="col-md-4">
                                        <label>PUBLIC SCHOOL NAME</label>
                                        <div>{decode(result.public_school_name)}</div>
                                    </div>:null   
                                }

                                {result.status1 === "SEVP SCHOOL"?
                                    <div class="col-md-4">
                                        <label>SEVP-CERTIFIED SCHOOL NAME</label>
                                        <div>{decode(result.sevp_school)}</div>
                                    </div>:null   
                                }

                                {result.status1 === "NON-MEMBER PRIVATE SCHOOL"?
                                <div class="col-md-4">
                                    <label>NON-MEMBER PRIVATE SCHOOL NAME</label>
                                    <div>{decode(result.private_school_name)}</div>
                                </div>:null   
                                }

                                {result.status1 === "VIA CSIET-APPROVED EXCHANGE PROGRAM"?
                                    <div class="col-md-4">
                                        <label>CSIET-APPROVED EXCHANGE PROGRAM NAME</label>
                                        <div>{decode(result.csiet_foreign_exchange.name)}</div>
                                    </div>:null   
                                }


                                {result.status1 === "AES SCHOOL"?
                                    <div class="col-md-4">
                                        <label>Previous AES School</label>
                                        <div>{decode(result.aesname)}</div>
                                    </div>:null 
                                }
                                
                            </div>

                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>Date Created</label>
                                    <div>{moment(result.createdAt).format('LL')}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Date Updated</label>
                                    <div>{moment(result.updatedAt).format('LL')}<br/>
                                    </div>
                                </div>
                                
                                {result.aes_status ==="NO"?
                                <div class="col-md-4">
                                    <label>XFR</label>
                                    <div>NO<br/>
                                    </div>
                                </div>:
                                <div class="col-md-4">
                                <label>XFR</label>
                                <div style={{color:'tomato', fontWeight:800}}>YES<br/>
                                </div>
                            </div>
                                }
                                
                            </div>

                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>HOS Ineligible Reason</label>
                                    <div>{result.ho_reject_reason}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>GIAA Ineligible Reason</label>
                                    <div>{result.gisa_reject_reason}<br/>
                                    </div>
                                    
                                </div>
                                
                                <div class="col-md-4">
                                    <label>Notes</label>
                                    <div>{result.notes}<br/>
                                    </div>
                                    
                                </div>
                                
                            </div>

                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>GIAA STATUS</label>
                                    {result.gisa_approval === "APPROVED"?
                                    <div style={{color:"green"}}>
                                        {result.gisa_approval}
                                    </div>:null
                                    }
                                    {result.gisa_approval === "REJECTED"?
                                    <div style={{color:"red"}}>
                                        {result.gisa_approval}
                                    </div>:null
                                    }
                                    {result.gisa_approval === "PENDING"?
                                    <div style={{color:"blue"}}>
                                        {result.gisa_approval}
                                    </div>:null
                                    }
                                </div>
                                <div class="col-md-4">
                                    <label>HOS STATUS</label>
                                    {result.ho_approval === "APPROVED"?
                                    <div style={{color:"green"}}>
                                        {result.ho_approval}
                                    </div>:null
                                    }
                                    {result.ho_approval === "REJECTED"?
                                    <div style={{color:"red"}}>
                                        {result.ho_approval}
                                    </div>:null
                                    }
                                    {result.ho_approval === "PENDING"?
                                    <div style={{color:"blue"}}>
                                        {result.ho_approval}
                                    </div>:null
                                    }
                                </div>
                                
                                <div class="col-md-4">
                                    <label>GIAA APPROVED ON</label>
                                    <div>{result.gisa_approval === "APPROVED"?moment(result.gisa_approved_on).format("MMMM DD, YYYY"):null }<br/>
                                    </div>
                                    
                                </div>
                                
                            </div>

                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>HOS APPROVED ON</label>
                                    <div>{result.ho_approval === "APPROVED"?moment(result.ho_approved_on).format("MMMM DD, YYYY"):null }</div>
                                </div> 

                                <div class="col-md-4">
                                    <label>Unit</label>
                                    <div>{result.units_passed}<br/>
                                    </div>
                                    
                                </div>

                                <div class="col-md-4">
                                    <label>International School</label>
                                    <div>{result.international_school}<br/>
                                    </div>
                                    
                                </div>
                            </div>

                            
                                <div class="row tab-section">
                                    {result.fileURL?
                                        <div class="col-md-4">
                                            <label>Uploaded document</label>
                                            <div>
                                                <a href={result.fileURL} target="_blank" rel="noreferrer noopener">
                                                    Click here to download
                                                </a>
                                            </div>
                                        </div>:null 
                                    }
                                    {result.fileurl_8th?
                                        <div class="col-md-4">
                                            <label>8th grade document</label>
                                            <div>
                                                <a href={result.fileurl_8th} target="_blank" rel="noreferrer noopener">
                                                    Click here to download
                                                </a>
                                            </div>
                                        </div>:null
                                    }
                                </div>
                           

                           
                               
                           

                            <div className="list-action-wrpr showicons roundicons-text">
								<div className="list-action-wrpr">
                                    <button  onClick={()=>{navigate("/athlet_edit/"+sid+"/"+result.id)}}
                                        style={{marginLeft:'20px', marginRight:'20px'}} 
                                        data-toggle="tooltip" title="Edit">
                                        <i class="edit icon-pencil3"></i>
                                        <span>Update</span>
                                    </button>
                                    <button onClick={ ()=> { DeleteAthleticElig(result.id)}}
                                        style={{marginLeft:'20px', marginRight:'20px'}}
                                         data-toggle="tooltip" title="Delete" id={result.id}>
                                            <i class="delete icon-close1"></i>
                                            <span>Delete</span>
                                   </button>
                                </div>
                            </div>

                            
                            {/* <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>CSIET Foreign exchange program </label>
                                    <div>{result.csiet_foreign_exchange}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Gisa approved International program </label>
                                    <div>{result.gisa_foreign_exchange}<br/>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>Date of transfer</label>
                                    <div>{result.date_transfered}<br/>
                                    </div>
                                    
                                </div>
                                
                            </div>
                             */}

                                
                           
                        </div>

                    </div>



                </div>
            </aside>
        </div>
    )
}

export default AthletView;